import React, { FunctionComponent } from 'react'
import { UseFormSetValue } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

// import { AppointmentDateRangePicker } from '..'

import { LabelInputField } from '../LabelInputField/LabelInputField'

import { RecurrenceOptionsWrapper } from './style'

interface IProps {
  setValue: UseFormSetValue<any>
  watchRepeatOption: any
}

export const RecurrenceRange: FunctionComponent<IProps> = ({
  setValue,
  watchRepeatOption,
}) => {
  const { t } = useTranslation()

  if (watchRepeatOption === 'never') {
    return null
  }

  if (watchRepeatOption === 'stopOnDate') {
    return (
      <RecurrenceOptionsWrapper>
        <p>{'Code is commented atm.'}</p>
        {/* <AppointmentDateRangePicker setValue={setValue} />*/}
      </RecurrenceOptionsWrapper>
    )
  }

  return (
    <LabelInputField
      fieldLabel={t('times')}
      fieldColor="#005cd9"
      type="number"
      placeholder="10"
      initialValue="10"
      min={1}
      onChange={e => setValue('repeatStopsAfter', e.target.value)}
    />
  )
}
